import React, { useState, useEffect, useRef } from "react";
import banner1 from "../Assets/bannerPartner.jpg";
import "./partner.css";
import partnerImg1 from "../Assets/Partner/partnerImg1.png";
import partnerImg2 from "../Assets/Partner/partnerImg2.png";
import pointerImg from "../Assets/Partner/partnerPointer.png";
import pointerImg2 from "../Assets/Partner/partnerPointer2.png";
import part1 from "../Assets/Partner/part1.png";
import part2 from "../Assets/Partner/part2.png";
import part3 from "../Assets/Partner/part3.png";
import part4 from "../Assets/Partner/part4.png";
import part5 from "../Assets/Partner/part5.png";
import part6 from "../Assets/Partner/part6.png";
import tabPointer from "../Assets/Partner/tabsArrow.png";
import tabPointer2 from "../Assets/Partner/tabsArrow2.png";
import tab1Img1 from "../Assets/Partner/tab1Img1.png";
import tab1Img2 from "../Assets/Partner/tab1Img2.png";
import tab1Img3 from "../Assets/Partner/tab1Img3.png";
import tab2Img1 from "../Assets/Partner/tab2Img1.png";
import tab2Img2 from "../Assets/Partner/tab2Img2.png";
import tab2Img3 from "../Assets/Partner/tab2Img3.png";
import tab3Img1 from "../Assets/Partner/tab3Img1.png";
import tab3Img2 from "../Assets/Partner/tab3Img2.png";
import tab3Img3 from "../Assets/Partner/tab3Img3.png";
import tab4Img1 from "../Assets/Partner/tab4Img1.png";
import tab4Img2 from "../Assets/Partner/tab4Img2.png";
import tab4Img3 from "../Assets/Partner/tab4Img3.png";
import tab6Img1 from "../Assets/Partner/tab6Img1.png";
import tab6Img2 from "../Assets/Partner/tab6Img2.png";
import tab6Img3 from "../Assets/Partner/tab6Img3.png";
import bulletPoint from "../Assets/Partner/bulletPoint.png";
import { Table } from "react-bootstrap";
import hornImg from "../Assets/Partner/announcement1.gif";
import hron2 from "../Assets/Partner/aaa.jpg";
import Modal from "react-bootstrap/Modal";

function highlightMultiple(text, highlights) {
  let elements = [text];
  highlights.forEach((highlight, idx) => {
    elements = elements.flatMap((str) => {
      if (typeof str !== "string") return [str];
      const parts = str.split(highlight);
      return parts.reduce(
        (acc, part, i) =>
          i < parts.length - 1
            ? [
                ...acc,
                part,
                <span
                  key={highlight + idx + i}
                  style={{
                    // background: "#FFF3ED",
                    color: "#FB6340",
                    fontWeight: "bold",
                  }}
                >
                  {highlight}
                </span>,
              ]
            : [...acc, part],
        []
      );
    });
  });
  return elements;
}

function PartnerPage() {
  const [activeTab, setActiveTab] = useState(1);
  const [showAnnouncement, setShowAnnouncement] = useState(false);
  const partnerContent1 = [
    {
      id: 1,
      description:
        "Channel Partnerships as Revenue-Sharing Franchisees invitations vide TENDERS for trades like: Land Owners Agencies & Charge Point Operators.",
    },
    {
      id: 2,
      description:
        "Work Contractors for job description vide tenders amongst varied trades involved like: Electrical Works, Civil Works, Steel Fabrication, Electric Vehicle Charging-Swapping Equipment Supply & Maintenance, Digital & Networking, Advertising Boards-LED Screens, 2W / 3W / 4W EVs (sales & service) centres with other Transit Infra and many more.",
    },
    {
      id: 3,
      description:
        "Channel Partnerships as Revenue-Sharing Franchisees invitations vide AUCTIONS for trades like: E-Mobility Service Providers & Ads - Media.",
    },
    {
      id: 4,
      description:
        "The pre-determined parking slots values as per power load allotments for the e-fleet / e-taxi / e-bus consumption on range of battery packs offered.",
    },
  ];

  const partnerContent2 = [
    {
      id: 1,
      head: "",
      description:
        "SERVES DriEVs INDIA is Renewable Powered E-Mobility Mass-Transition Digitized (RED) Electric Vehicle (EV) Public Charging Station (PCS) program operated on a German Patented Utility Process System for sustainability.",
    },
    {
      id: 2,
      head: "",
      description:
        "The program is the premier network chain of mass public charging stations for E-Mobility Service Providers [E-MSPs] like fleet operators, taxi aggregators, public transporters of 2/3/4 Wheelers to passengers e-Buses or LMVs to goods-trucks of Land Mode, e-Boats & Water-Crafts of Water Mode & E-VTOL Aircrafts-Drones of Air Mode.",
    },
    {
      id: 3,
      head: "",
      description:
        "The RED: EV-PCS DriEVs even 100 EVs to 1000 plus EVs daily consuming minimum 4000 Power Units a day while increase in EVs upgrades multiples of Power Units intake capacity depending on size/location/duration of land.",
    },
  ];

  const handleChangeTab = (tab) => {
    setActiveTab(tab);
  };

  const tab1content = [
    {
      id: 1,
      description:
        "Land Plots along land areas can stage dual-dimensional EV charging-swapping facility for EVs of Land-Mode & Air-Mode.",
    },
    {
      id: 2,
      description:
        "Land Plots along water bodies can accommodate the dual-dimensional as well as tri-dimensional charging-swapping facility for EVs of Land-Mode, Water-Mode & Air-Mode too.",
    },
    {
      id: 3,
      description:
        "The EVs in Land-Mode include 2W/3W/4W, e-Buses, e-Trucks, etc., in Water-Mode EVs like e-boats and other watercrafts & Air-Mode the EVs are Vertical Take-Off & Landing (e-VTOL) aircrafts like drones, etc. flying towards Sky-side.",
    },
    {
      id: 4,
      description:
        "These combinations are feasible only if & when permitted as per the GoI Standards & Guidelines accordingly subject to necessary approvals by Evaluation & Scrutiny Committee.",
    },
  ];

  const tab2content = [
    {
      id: 1,
      description:
        "“SERVES” RED: EV-PCS Revenue-Sharing Franchisees in two categories:",
      subPoints: [
        {
          id: 1,
          desc: "Land Owner Agency (LOA) Franchisees fulfils procurement of Land on Long Lease for Retail Outlets [EVCS];",
        },
        {
          id: 2,
          desc: "Charge Point Operator (CPO) Franchisees operates charging – swapping & allied systems at Retail Outlets [EVCS).",
        },
      ],
    },
    {
      id: 2,
      description:
        "The LOA franchisee applicants apply on website by advance payment of Document Charges for accessing to follow the Project Document for locations at regular cities, outskirts, highways, expressway or mahamarg for procurement of land on long-lease, on preference for CPO Franchisees appointments, but not mandatory.",
    },
    {
      id: 3,
      description:
        "But, if any LOA franchisee opts out of preferred appointment of CPO Franchisee voluntarily, then the CPO Franchisee opportunity shall be advertised on website for direct applications or even allotted to any Letter of Interest receipt recommended by the Evaluation & Scrutiny Committee.",
    },
    {
      id: 4,
      description:
        "Further, in case of the Forts also the LOAs franchisee applicants applies on website by advance payment of Document Charges for accessing to follow the Project Document for locations at the foothills of the forts at villages for procurement of land on long-lease, but the CPO Franchisee appointments is to be routed via a state distribution system decided by the Evaluation & Scrutiny Committee to be declared to the applicants on-time.",
    },
  ];

  const tab3content = [
    {
      id: 1,
      description:
        "The Private Land Owner Agencies invited as “SERVES” ‘RED: EV-PCS’ Franchisees for Cities, Outskirts, Highways or Foothills at Fort Villages to appoint LOA Franchisees are exclusive owners, co-owners, group of smaller land parcels, co-operative societies, institutions, business parks-hubs, commercial complexes, hotels-motels, etc.",
    },

    {
      id: 2,
      description:
        "Preference is for any Central / PSUs / State / Corporations / Regional / District/ Local Government Bodies /Public Entities of any government offices or their specified institutions:",
      subPoints: [
        {
          id: 1,
          desc: "Their utility or amenity lands allotted C & M - DBFOT Concessionaires or any other such allottees in advertisements for any locations like Highways / Expressway / Mahamarg.",
        },
        {
          id: 2,
          desc: "Their other properties can be under private-public partnerships on agreements as per GoI recommended Revenue-Sharing Agreement as “Provisions of Public Land at Promotional Rates‟ in Clause 7.0 amid 17.09.2024’ GoI-MHI guidelines on endorsed agreement period and floor price bid OR otherwise as SDI’s RED: EV-PCS LOA & CPO franchisees too.",
        },
      ],
    },
  ];

  const tab4content = [
    {
      id: 1,
      description:
        "“SERVES” RED: EV-PCS Plot Areas with entry/exit driveable access from LOA Franchisees:",
      subPoint1:
        "At Cities, Outskirts, Highways, Expressway or Mahamarg in Maharashtra:",
      subPoint2:
        "At foothills of forts at upto 350+ of the 457 Fort Village Locations in Maharashtra:",
      subPoints1: [
        {
          id: 1,
          desc: "500+ sq. m till 3000+ sq. m for 5 years to 25 years long-lease periods;",
        },
        {
          id: 2,
          desc: "3001+ sq. m till 6000+ sq. m for 10 years to 25 years long-lease periods;",
        },
        {
          id: 3,
          desc: "6001+ sq. m till 9000+ sq. m for 15 years to 25 years long-lease periods;",
        },
        {
          id: 4,
          desc: "9001+ sq. m till 12000+ sq. m for 20 years to 25 years long-lease periods;",
        },
        {
          id: 5,
          desc: "12001+ sq. m till 15000+ sq. m for 25 years long-lease periods only;",
        },
      ],
      subPoints2: [
        {
          id: 1,
          desc: "FORT FOOTHILLS: 500+ sq. m till 3000+ sq. m for 25 years long-lease periods only;",
        },
      ],
    },
  ];

  const tab6content = [
    {
      id: 1,
      description:
        "Anyone interested for LOA Franchisee for your own location, can access the ‘Project Locations’ on Website to apply for your selective location in the respective projects stated:",
      subPoints: [
        {
          id: 1,
          desc: "Initially proceed to ‘Projects’ instead of Tender on website https://www.icorp.global & follow the instructions as you’ve to mandatorily pay per applicant per plot, the Project Document Charges: Rs. 2500/- (+) 18% GST: Rs. 450/- (=) Rs. 2950/-, forward the downloaded payment receipt by your registered mail id to servesdrievsindia@gmail.com & receive your copy set of Project Document on your registered email id only.",
        },
        {
          id: 2,
          desc: "Go through the Project Document in detail, jot down all your queries if any & send a mail to servesdrievsindia@gmail.com for a Virtual Pre-Bid Meet to be arranged or clubbed with others, intimated to your registered email id.",
        },
        {
          id: 3,
          desc: "After the Pre-Bid Meet, once your queries are answered & cleared, then you can proceed with the process of Franchisee Application as prescribed by following the instructions therein like Payments of the Project Process Fees: Rs. 25,000/- (+) 18% GST: Rs. 4,500/- (=) Rs. 29,500/- or Earnest Money Deposit: Rs. 2,50,000/- (refundable - NO GST), SUBMISSIONS of the TECHNICAL BID with necessary DOCUMENTS  &  COMMERCIAL BID OFFER for the same to servesdrievsindia@gmail.com.",
        },
        {
          id: 4,
          desc: "Then, after the Project Processed with all the needed Evaluations & Scrutiny, the applicant shall be intimated of the further developments, finally with the Letter of Intent awarded to you & the EMD Amount after any deductions, the refund credited to your bank account.",
        },
        {
          id: 5,
          desc: "Further, as per the schedule of your location for activations, the applicant shall be intimated of the further developments in series so  as to proceed to complete all the necessary formalities of the specific Project Process leading to commence the operations within the project time-line.",
        },
      ],
    },
  ];

  const highlights = [
    "Project Document Charges: Rs. 2500/- (+) 18% GST: Rs. 450/- (=) Rs. 2950/-",
    "Project Process Fees: Rs. 25,000/- (+) 18% GST: Rs. 4,500/- (=) Rs. 29,500/-",
    "Earnest Money Deposit: Rs. 2,50,000/- (refundable - NO GST)",
  ];

  const data = [
    {
      id: 1,
      soloFee: "10620000",
      soloAsset: "125",
      combiFee: "21240000",
      combiAsset: "250",
      openLand: "500 to 3000",
      longLease: "5 / 10 / 15 / 20 / 25",
      parkingSlot: "12 to 72",
      wheelerEv: "192 to 1152",
    },
    {
      id: 2,
      soloFee: "12744000",
      soloAsset: "150",
      combiFee: "25488000",
      combiAsset: "300",
      openLand: "3001 to 6000",
      longLease: "10 / 15 / 20 / 25",
      parkingSlot: "68 to 135",
      wheelerEv: "1088 to 2160",
    },
    {
      id: 3,
      soloFee: "16992000",
      soloAsset: "200",
      combiFee: "33984000",
      combiAsset: "400",
      openLand: "6001 to 9000",
      longLease: "15 / 20 / 25",
      parkingSlot: "126 to 189",
      wheelerEv: "2016 to 3024",
    },
    {
      id: 4,
      soloFee: "21240000",
      soloAsset: "250",
      combiFee: "42480000",
      combiAsset: "500",
      openLand: "9001 to 12000",
      longLease: "20 / 25",
      parkingSlot: "176 to 234",
      wheelerEv: "2816 to 3744",
    },
    {
      id: 5,
      soloFee: "25488000",
      soloAsset: "300",
      combiFee: "50976000",
      combiAsset: "600",
      openLand: "12001 to 15000",
      longLease: "25",
      parkingSlot: "216 to 270",
      wheelerEv: "3456 to 4320",
    },
  ];

  const [isExiting, setIsExiting] = useState(false);

  const handleShowAnnouncement = () => {
    setShowAnnouncement(true);
  };

  const handleClose = () => {
    setIsExiting(true);
    setTimeout(() => {
      setShowAnnouncement(false);
      setIsExiting(false);
    }, 200);
  };

  return (
    <div className="partner-main-container">
      <div className="partner-banner">
        <img src={banner1} alt="img" />
        <div className="opaque-screen"></div>
        <div className="partner-banner-heading">
          <div>Charge Up Your Business </div>
          <div>with EV Partnerships</div>
        </div>
      </div>
      <div
        className="aboutUs-container"
        style={{ paddingTop: "70px", paddingBottom: "70px" }}
      >
        <div className="aboutUs-cont-inner">
          <svg
            className="about-svg1"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 414.35 414.322"
          >
            <g
              id="Group_16"
              data-name="Group 16"
              transform="translate(-5995.863 -1507.947)"
              opacity="0.5"
            >
              <path
                id="Path_100"
                data-name="Path 100"
                d="M518.286,856.444a5.054,5.054,0,1,0,0,10.082c28.1,0,40.651-23.2,53.932-47.775,17.287-31.994,36.86-68.289,94.825-72.913a14.975,14.975,0,0,0,12.636-20.352l-25.81-68.853A180.134,180.134,0,0,0,703.634,622.7a5.109,5.109,0,0,0,1.4-4.382,5.027,5.027,0,0,0-2.688-3.71l-80.791-40.328a3.711,3.711,0,0,0-1.264-.43L519.308,553.634a5.215,5.215,0,0,0-6.076,3.844,5.055,5.055,0,0,0,3.952,5.942l98.239,19.626,25.353,67.617a70.651,70.651,0,0,1-21.508,3.737H518.286a5.055,5.055,0,1,0,0,10.082H619.268a80.354,80.354,0,0,0,25.165-4.355l25.81,68.827a5.081,5.081,0,0,1-4.033,6.748c-63.4,5.082-85.28,45.705-102.864,78.156C550.495,837.677,540.386,856.444,518.286,856.444Zm110.23-267.456,62.724,31.375a169.839,169.839,0,0,1-40.946,26.885Z"
                transform="translate(5483 974.926)"
                fill="#c3e3a8"
              />
              <path
                id="Path_101"
                data-name="Path 101"
                d="M628.932,636.15a85.845,85.845,0,1,0,85.818,85.827A85.845,85.845,0,0,0,628.932,636.15Zm0,161.554a75.736,75.736,0,1,1,75.736-75.736A75.736,75.736,0,0,1,628.932,797.7Z"
                transform="translate(5533.989 1114.429)"
                fill="#c3e3a8"
              />
              <path
                id="Path_102"
                data-name="Path 102"
                d="M616.251,643.66A65.654,65.654,0,1,0,681.878,709.3,65.654,65.654,0,0,0,616.251,643.66Zm0,121.172A55.545,55.545,0,1,1,671.769,709.3,55.545,55.545,0,0,1,616.251,764.832Z"
                transform="translate(5546.67 1127.11)"
                fill="#c3e3a8"
              />
              <path
                id="Path_103"
                data-name="Path 103"
                d="M624.731,682.938l11.077-11.077a5.057,5.057,0,1,0-7.151-7.151L617.58,675.787a25.648,25.648,0,0,0-8.872-3.683V656.456a5.055,5.055,0,1,0-10.082,0V672.1a25.652,25.652,0,0,0-8.872,3.683L578.677,664.71a5.054,5.054,0,0,0-7.125,7.151l11.077,11.077a25.192,25.192,0,0,0-3.71,8.872H563.406a5.054,5.054,0,1,0,0,10.082h15.647a25.189,25.189,0,0,0,3.71,8.872l-11.292,11.077a5.038,5.038,0,1,0,7.125,7.125l11.077-11.077a24.653,24.653,0,0,0,8.872,3.683v15.674a5.054,5.054,0,1,0,10.082,0V721.573a24.652,24.652,0,0,0,8.872-3.683l11.077,11.077a5.054,5.054,0,0,0,7.151-7.125L624.65,710.765a25.646,25.646,0,0,0,3.683-8.872h15.728a5.054,5.054,0,1,0,0-10.082H628.414A25.654,25.654,0,0,0,624.731,682.938Zm-21,29.063a15.163,15.163,0,1,1,15.136-15.163A15.164,15.164,0,0,1,603.734,712Z"
                transform="translate(5559.188 1139.559)"
                fill="#c3e3a8"
              />
              <path
                id="Path_104"
                data-name="Path 104"
                d="M581.174,608.681a5.055,5.055,0,1,0,0-10.082H540.846a5.054,5.054,0,1,0,0,10.082Z"
                transform="translate(5521.093 1050.999)"
                fill="#c3e3a8"
              />
              <path
                id="Path_105"
                data-name="Path 105"
                d="M609.616,616.192a14.463,14.463,0,0,1,7.5,2.124,5.054,5.054,0,1,0,5.162-8.684,24.573,24.573,0,0,0-12.663-3.522,25.245,25.245,0,1,0,0,50.491,24.842,24.842,0,0,0,12.663-3.522,5.054,5.054,0,1,0-5.162-8.684,14.438,14.438,0,0,1-7.5,2.1,15.163,15.163,0,1,1,0-30.3Z"
                transform="translate(5603.743 1063.705)"
                fill="#c3e3a8"
              />
              <path
                id="Path_106"
                data-name="Path 106"
                d="M518.252,899.6H558.58a25.272,25.272,0,0,0,25.245-25.245,95.947,95.947,0,1,1,191.894,0,25.245,25.245,0,1,0,50.477,0V858.706a25.273,25.273,0,0,0,20.191-24.735V793.509A25.272,25.272,0,0,0,826.2,768.774V753.181a50.166,50.166,0,0,0-2.957-15.109h38.312a45.517,45.517,0,0,0,45.436-45.463V616.872h15.136a5.054,5.054,0,0,0,5.054-5.028V571.517a5.055,5.055,0,0,0-5.055-5.055V551.326a5.054,5.054,0,1,0-10.082,0v15.136H891.824V551.326a5.054,5.054,0,1,0-10.082,0v15.136a5.054,5.054,0,0,0-5.054,5.054v40.328a5.055,5.055,0,0,0,5.054,5.028h15.136v75.736a35.381,35.381,0,0,1-35.327,35.354h-42.1c-20.03-46.35-78.344-118.86-92.4-136.013l16.938-16.965a4.974,4.974,0,0,0,1.183-5.377,5.081,5.081,0,0,0-4.3-3.334l-222.154-20.11a5.108,5.108,0,0,0-5.377,4.571,5.054,5.054,0,0,0,4.571,5.377l211.427,19.223-12.582,12.582a5.082,5.082,0,0,0-.3,6.8c22.234,26.7,72.913,91.948,92.163,133.109h-78.29a5.054,5.054,0,0,0,0,10.109h82.431a45.976,45.976,0,0,1,3.388,15.11V768.21H780.815a5.054,5.054,0,0,0-5.054,5.027v34.145a5,5,0,0,0,.86,2.689,108.561,108.561,0,0,1,17.583,44.6,5.028,5.028,0,0,0,4.974,4.275h16.965v15.136a15.163,15.163,0,1,1-30.3,0,106.029,106.029,0,1,0-212.058,0,15.19,15.19,0,0,1-15.15,15.163H518.305a5.054,5.054,0,1,0,0,10.082ZM886.9,606.79v-30.3h30.273v30.3ZM803.56,849.108a118.1,118.1,0,0,0-17.61-43.017V778.426H821.3a15.19,15.19,0,0,1,15.056,15.083v40.328A15.163,15.163,0,0,1,821.2,848.974Z"
                transform="translate(5483.034 962.043)"
                fill="#c3e3a8"
              />
            </g>
          </svg>
          <div className="aboutUs-left">
            <img src={partnerImg1} alt="car-image" />
          </div>
          <div className="aboutUs-right">
            {Array.isArray(partnerContent1)
              ? partnerContent1.map((itm) => (
                  <div
                    className="d-flex align-items-start gap-3 mb-3"
                    key={itm.id}
                  >
                    <img
                      width={"17px"}
                      className="mt-1 pp-right-img"
                      src={pointerImg}
                      alt="img"
                    />
                    <div className="aboutUs-descrip">{itm.description}</div>
                  </div>
                ))
              : null}
          </div>
          <svg
            className="about-svg2"
            style={{ bottom: "-17%", zIndex: 1 }}
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 556.111 556.111"
          >
            <g
              id="Group_15"
              data-name="Group 15"
              transform="translate(0)"
              opacity="0.37"
            >
              <path
                id="Path_76"
                data-name="Path 76"
                d="M470.728,444.193a33.908,33.908,0,1,1,67.817,0,33.114,33.114,0,0,1-11.267,25.025,6.789,6.789,0,0,0-.65,9.569,6.861,6.861,0,0,0,9.606.65,46.692,46.692,0,0,0,15.853-35.245,47.486,47.486,0,0,0-94.936,0,46.619,46.619,0,0,0,15.889,35.245,6.789,6.789,0,0,0,8.919-10.219A33.078,33.078,0,0,1,470.728,444.193Z"
                transform="translate(-321.517 -44.081)"
                fill="#118e1d"
                opacity="0.18"
              />
              <path
                id="Path_77"
                data-name="Path 77"
                d="M471.532,361.946H487.71l-22.245-44.417a6.789,6.789,0,1,1,12.133-6.067l27.12,54.167a6.789,6.789,0,0,1-6.067,9.822H482.546l22.208,44.417a6.789,6.789,0,1,1-12.133,6.067L465.5,371.768a6.789,6.789,0,0,1,6.067-9.822Z"
                transform="translate(-301.99 -280.551)"
                fill="#118e1d"
                opacity="0.18"
              />
              <path
                id="Path_78"
                data-name="Path 78"
                d="M672.175,469.849h-291.6V449.519a6.789,6.789,0,0,0-13.578,0v27.12a6.789,6.789,0,0,0,6.789,6.789H672.175a6.789,6.789,0,1,0,0-13.578Z"
                transform="translate(-122.853 72.684)"
                fill="#118e1d"
                opacity="0.18"
              />
              <path
                id="Path_79"
                data-name="Path 79"
                d="M693.757,530.57H571.666V849.323a6.789,6.789,0,0,1-6.753,6.789H456.4a6.789,6.789,0,1,1,0-13.578H557.943V523.889a6.789,6.789,0,0,1,6.789-6.789h20.33V475.645a33.945,33.945,0,0,1-27.119-33.222V333.908A33.945,33.945,0,0,1,591.852,300H673.5a33.945,33.945,0,0,1,33.909,33.908V442.422a33.944,33.944,0,0,1-27.155,33.222v41.383h20.367a6.789,6.789,0,0,1,6.789,6.789V767.964a6.789,6.789,0,0,1-13.578,0ZM666.638,476.4H598.821v40.625h67.817Zm6.861-13.65a20.367,20.367,0,0,0,20.331-20.331V333.908A20.367,20.367,0,0,0,673.5,313.578H592.1a20.367,20.367,0,0,0-20.367,20.331V442.422A20.367,20.367,0,0,0,592.1,462.753Z"
                transform="translate(-449.61 -300)"
                fill="#118e1d"
                opacity="0.18"
              />
              <path
                id="Path_80"
                data-name="Path 80"
                d="M545.313,367.61a6.789,6.789,0,0,1,6.753,6.789v54.167a6.789,6.789,0,0,1-6.753,6.789H463.919a6.789,6.789,0,0,1-6.789-6.789V374.4a6.789,6.789,0,0,1,6.789-6.789Zm-6.789,13.578H470.708v40.661h67.745Z"
                transform="translate(-321.424 -123.463)"
                fill="#118e1d"
                opacity="0.18"
              />
              <path
                id="Path_81"
                data-name="Path 81"
                d="M692.614,395.732v40.661h47.378a6.789,6.789,0,0,1,0,13.578H692.614v13.578a6.789,6.789,0,0,1-6.861,6.68H604.358a6.9,6.9,0,0,1-4.082-1.336l-27.119-20.33a6.824,6.824,0,0,1-2.708-5.453V422.779H522.892a20.366,20.366,0,0,0-20.33,20.33v54.167a20.367,20.367,0,0,0,20.331,20.331H685.753a33.944,33.944,0,0,1,33.908,33.908v54.167a33.944,33.944,0,0,1-33.908,34.269H373.789A6.789,6.789,0,0,1,367,633.162V538.118a6.789,6.789,0,1,1,13.578,0V626.3H685.753a20.367,20.367,0,0,0,20.331-20.331V551.8a20.367,20.367,0,0,0-20.331-20.331H522.892a33.944,33.944,0,0,1-33.908-33.908V443.4a33.944,33.944,0,0,1,33.908-33.908H570.45V389.159a6.825,6.825,0,0,1,2.708-5.453l27.12-20.331a6.9,6.9,0,0,1,4.081-1.336h81.394a6.789,6.789,0,0,1,6.789,6.753v13.578h47.45a6.789,6.789,0,1,1,0,13.578Zm-13.578-20.367H606.814l-22.606,16.972v47.45l22.606,16.972h72.222Z"
                transform="translate(-190.669 -138.007)"
                fill="#118e1d"
                opacity="0.18"
              />
            </g>
          </svg>
        </div>
      </div>
      <div className="partner-second-bg position-relative">
        <div className="aboutUs-cont-inner ms-5 ">
          <div className="aboutUs-right" style={{ width: "55%" }}>
            <div className="aboutUs-name mb-4">PROJECT HIGHLIGHTS</div>
            {Array.isArray(partnerContent2)
              ? partnerContent2.map((itm) => (
                  <div
                    className="d-flex align-items-start gap-3 mb-4"
                    key={itm.id}
                  >
                    <img
                      width={"17px"}
                      className="mt-1"
                      src={pointerImg2}
                      alt="img"
                    />
                    <div className="aboutUs-descrip">
                      <span
                        className={
                          itm.id == 1
                            ? "serves-highlight"
                            : itm.id == 3
                            ? "drives-highlight"
                            : ""
                        }
                      >
                        {itm.head}{" "}
                      </span>
                      {itm.description}
                    </div>
                  </div>
                ))
              : null}
          </div>
          <div className="aboutUs-left me-5" style={{ width: "auto" }}>
            <img src={partnerImg2} alt="car-image" className="partner-img-2" />
          </div>
        </div>
      </div>
      <div className="partner-third-bg">
        <div className="partner-third-inner">
          <div className="partner-tabs">
            <div className="row">
              <div className="col col-2 col-md-2 col-lg-2">
                <div
                  className={
                    activeTab === 1
                      ? "partner-tabs-tab active1"
                      : "partner-tabs-tab"
                  }
                  onClick={() => handleChangeTab(1)}
                >
                  <div>
                    <img src={part1} alt="ev-travels" />
                  </div>
                  <div className="tab-name">EV TRAVEL MODES</div>
                </div>
              </div>
              <div className="col col-2 col-md-2 col-lg-2">
                <div
                  className={
                    activeTab === 2
                      ? "partner-tabs-tab active2"
                      : "partner-tabs-tab"
                  }
                  onClick={() => handleChangeTab(2)}
                >
                  <div>
                    <img src={part2} alt="ev-travels" />
                  </div>
                  <div className="tab-name">FRANCHISEE CATEGORIES</div>
                </div>
              </div>
              <div className="col col-2 col-md-2 col-lg-2">
                <div
                  className={
                    activeTab === 3
                      ? "partner-tabs-tab active3"
                      : "partner-tabs-tab"
                  }
                  onClick={() => handleChangeTab(3)}
                >
                  <div>
                    <img src={part3} alt="ev-travels" />
                  </div>
                  <div className="tab-name">PRIVATE & PUBLIC LANDS</div>
                </div>
              </div>
              <div className="col col-2 col-md-2 col-lg-2">
                <div
                  className={
                    activeTab === 4
                      ? "partner-tabs-tab active4"
                      : "partner-tabs-tab"
                  }
                  onClick={() => handleChangeTab(4)}
                >
                  <div>
                    <img src={part4} alt="ev-travels" />
                  </div>
                  <div className="tab-name">PLOT AREA & ACCESS</div>
                </div>
              </div>

              <div className="col col-2 col-md-2 col-lg-2">
                <div
                  className={
                    activeTab === 5
                      ? "partner-tabs-tab active5"
                      : "partner-tabs-tab"
                  }
                  onClick={() => handleChangeTab(5)}
                >
                  <div>
                    <img src={part5} alt="ev-travels" />
                  </div>
                  <div className="tab-name">FRANCHISEE TARIFFS</div>
                </div>
              </div>
              <div className="col col-2 col-md-2 col-lg-2">
                <div
                  className={
                    activeTab === 6
                      ? "partner-tabs-tab active6"
                      : "partner-tabs-tab"
                  }
                  onClick={() => handleChangeTab(6)}
                >
                  <div>
                    <img src={part6} alt="ev-travels" />
                  </div>
                  <div className="tab-name">FRANCHISEE APPLICATION</div>
                </div>
              </div>
            </div>
          </div>
          {activeTab === 1 && (
            <div className="partner-tabs-content">
              <div className="heading mb-4">EV TRAVEL MODES</div>
              {Array.isArray(tab1content)
                ? tab1content.map((itm) => (
                    <div
                      className="d-flex align-items-start gap-3 mb-4"
                      key={itm.id}
                    >
                      <img
                        width={"19px"}
                        className="mt-1"
                        src={tabPointer}
                        alt="img"
                      />
                      <div className="aboutUs-descrip">{itm.description}</div>
                    </div>
                  ))
                : null}
              <div className="serves-block w-100 mt-5">
                <div className="serveBox">
                  <img src={tab1Img1} alt="car-image" />
                  <div className="fw-bold">
                    <div>Land Mode</div>
                    <div>2W/3W/4W</div>
                  </div>
                </div>
                <div className="serveBox">
                  <img src={tab1Img2} alt="car-image" />
                  <div className="fw-bold">
                    <div>Water Mode</div>
                    <div>E-Boats</div>
                  </div>
                </div>

                <div className="serveBox">
                  <img src={tab1Img3} alt="car-image" />
                  <div className="fw-bold">
                    <div>Air Mode</div>
                    <div>Drones</div>
                  </div>
                </div>
              </div>
            </div>
          )}
          {activeTab === 2 && (
            <div className="partner-tabs-content">
              <div className="heading mb-4">FRANCHISEE CATEGORIES</div>
              {Array.isArray(tab2content)
                ? tab2content.map((itm) => (
                    <div>
                      <div
                        className="d-flex align-items-start gap-3 mb-4"
                        key={itm.id}
                      >
                        <img
                          width={"19px"}
                          className="mt-1"
                          src={tabPointer}
                          alt="img"
                        />
                        <div className="aboutUs-descrip">{itm.description}</div>
                      </div>
                      <div className="mb-4">
                        {itm.subPoints &&
                          itm.subPoints.map((x) => (
                            <div
                              className="d-flex align-items-start gap-3 mb-4 ms-5"
                              key={x.id}
                            >
                              <img
                                width={"8px"}
                                className="mt-1"
                                src={tabPointer2}
                                alt="img"
                              />
                              <div className="aboutUs-descrip">{x.desc}</div>
                            </div>
                          ))}
                      </div>
                    </div>
                  ))
                : null}
              <div className="serves-block w-100 mt-5">
                <div className="serveBox">
                  <img src={tab2Img1} alt="car-image" />
                  <div className="fw-bold">
                    <div>Land Owner Agency </div>
                    <div>(LOA)</div>
                  </div>
                </div>
                <div className="serveBox">
                  <img src={tab2Img2} alt="car-image" />
                  <div className="fw-bold">
                    <div>Charge Points operator </div>
                    <div>(CPO)</div>
                  </div>
                </div>

                <div className="serveBox">
                  <img src={tab2Img3} alt="car-image" />
                  <div className="fw-bold">
                    <div>LOA & CPO</div>
                    <div>Partnership</div>
                  </div>
                </div>
              </div>
            </div>
          )}
          {activeTab === 3 && (
            <div className="partner-tabs-content">
              <div className="heading mb-4">PRIVATE & PUBLIC LANDS</div>
              {Array.isArray(tab3content)
                ? tab3content.map((itm) => (
                    <div>
                      <div
                        className="d-flex align-items-start gap-3 mb-4"
                        key={itm.id}
                      >
                        <img
                          width={"19px"}
                          className="mt-1"
                          src={tabPointer}
                          alt="img"
                        />
                        <div className="aboutUs-descrip">{itm.description}</div>
                      </div>
                      <div className="mb-4">
                        {itm.subPoints &&
                          itm.subPoints.map((x) => (
                            <div
                              className="d-flex align-items-start gap-3 mb-4 ms-5"
                              key={x.id}
                            >
                              <img
                                width={"8px"}
                                className="mt-1"
                                src={tabPointer2}
                                alt="img"
                              />
                              <div className="aboutUs-descrip">{x.desc}</div>
                            </div>
                          ))}
                      </div>
                    </div>
                  ))
                : null}
              <div className="serves-block w-100 mt-5">
                <div className="serveBox">
                  <img src={tab3Img1} alt="car-image" />
                  <div className="fw-bold">
                    <div>Public Land</div>
                    {/* <div>(LOA)</div> */}
                  </div>
                </div>
                <div className="serveBox">
                  <img src={tab3Img2} alt="car-image" />
                  <div className="fw-bold">
                    <div>Private Land</div>
                    {/* <div>(CPO)</div> */}
                  </div>
                </div>

                <div className="serveBox">
                  <img src={tab3Img3} alt="car-image" />
                  <div className="fw-bold">
                    <div>Private-Public Partnership</div>
                    {/* <div></div> */}
                  </div>
                </div>
              </div>
            </div>
          )}
          {activeTab === 4 && (
            <div className="partner-tabs-content">
              <div className="heading mb-4">PLOT AREA & ACCESS</div>
              {Array.isArray(tab4content)
                ? tab4content.map((itm) => (
                    <div>
                      <div
                        className="d-flex align-items-start gap-3 mb-4"
                        key={itm.id}
                      >
                        <img
                          width={"19px"}
                          className="mt-1"
                          src={tabPointer}
                          alt="img"
                        />
                        <div className="aboutUs-descrip">{itm.description}</div>
                      </div>
                      <div className="mb-4">
                        <div className="d-flex align-items-start gap-3 mb-4 ms-5">
                          <img
                            width={"8px"}
                            className="mt-1"
                            src={tabPointer2}
                            alt="img"
                          />
                          <div className="aboutUs-descrip">{itm.subPoint1}</div>
                        </div>
                        {itm.subPoints1 &&
                          itm.subPoints1.map((x) => (
                            <div
                              className="d-flex align-items-start gap-3 mb-4"
                              style={{ marginLeft: "70px" }}
                              key={x.id}
                            >
                              <img
                                width={"6px"}
                                height={"6px"}
                                className="mt-2"
                                src={bulletPoint}
                                alt="img"
                              />
                              <div className="aboutUs-descrip">{x.desc}</div>
                            </div>
                          ))}
                        <div className="d-flex align-items-start gap-3 mb-4 ms-5">
                          <img
                            width={"8px"}
                            className="mt-1"
                            src={tabPointer2}
                            alt="img"
                          />
                          <div className="aboutUs-descrip">{itm.subPoint2}</div>
                        </div>
                        {itm.subPoints2 &&
                          itm.subPoints2.map((x) => (
                            <div
                              className="d-flex align-items-start gap-3 mb-4"
                              style={{ marginLeft: "70px" }}
                              key={x.id}
                            >
                              <img
                                width={"6px"}
                                height={"6px"}
                                className="mt-2"
                                src={bulletPoint}
                                alt="img"
                              />
                              <div className="aboutUs-descrip">{x.desc}</div>
                            </div>
                          ))}
                      </div>
                    </div>
                  ))
                : null}
              <div className="serves-block w-100 mt-5">
                <div className="serveBox">
                  <img src={tab4Img1} alt="car-image" />
                  <div className="fw-bold">
                    <div>City Plot Area</div>
                  </div>
                </div>
                <div className="serveBox">
                  <img src={tab4Img2} alt="car-image" />
                  <div className="fw-bold">
                    <div>Outskirts Plot Area</div>
                  </div>
                </div>

                <div className="serveBox">
                  <img src={tab4Img3} alt="car-image" />
                  <div className="fw-bold">
                    <div>Highways</div>
                  </div>
                </div>
              </div>
            </div>
          )}
          {activeTab === 5 && (
            <div className="partner-tabs-content">
              <div className="heading mb-4">FRANCHISEE TARIFFS</div>
              <div className="partner-table">
                <div className="">
                  <div className="table-responsive">
                    <Table hover responsive>
                      <thead>
                        {/* First row for grouped headers */}
                        <tr>
                          <th rowSpan="1">FRANCHISEE</th>
                          <th colSpan="2">LOA or CPO @ Rs.</th>
                          <th colSpan="2">LOA or CPO @ Rs.</th>
                          <th colSpan="1">OPEN LAND PLOT</th>
                          <th colSpan="1">LONG-LEASE</th>
                          <th colSpan="1">PARKING SLOTS</th>
                          <th colSpan="1">2-3/4-WHEELER EVs</th>
                        </tr>
                        {/* Second row for sub-columns */}
                        <tr>
                          <th>Packs</th>
                          <th>Solo-Fees</th>
                          <th>Solo-Assets</th>
                          <th>Combi-Fees</th>
                          <th>Combi-Assets</th>
                          <th>In Square Meters</th>
                          <th>Period In Years</th>
                          <th>2.5 m (*) 5.0 m</th>
                          <th>S/FCP Charge-Swap</th>
                        </tr>
                      </thead>
                      <tbody>
                        {data.map((row) => (
                          <tr key={row.id}>
                            <td>{row.id}</td>
                            <td>{row.soloFee}</td>
                            <td>{row.soloAsset}</td>
                            <td>{row.combiFee}</td>
                            <td>{row.combiAsset}</td>
                            <td>{row.openLand}</td>
                            <td>{row.longLease}</td>
                            <td>{row.parkingSlot}</td>
                            <td>{row.wheelerEv}</td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  </div>
                </div>
              </div>
              <div className="mt-3 tab3-note">
                [1] Tax deduction at source or any scheme or payment gateway
                charges, if any, deductions from due payments; [2] Plot
                feasibility determines power transformer capacity; [3] On
                parking slots demand, every power load intake capacity upgraded
                in 1 MW multiples less decimals till next upgrade; [4]
                Franchisee open land plots on 25 years long-lease fetches the
                highest & 5 years long-lease fetches the lowest margin of the
                revenue share; [5] Franchisee Pack of 500 to 3000 sq. m open
                land plots for 25 years long-lease periods are valid for the
                foothills of the forts in Maharashtra
              </div>
            </div>
          )}
          {activeTab === 6 && (
            <div className="partner-tabs-content">
              <div className="heading d-flex justify-content-between gap-2 position-relative">
                <div className="w-100">FRANCHISEE APPLICATION</div>
              </div>
              <div className="announcement-cont">
                <div
                  className="click-me-annc mb-4"
                  onClick={handleShowAnnouncement}
                >
                  <img
                    className="me-1"
                    src={hornImg}
                    alt="annoucement"
                    width={35}
                  />
                  Click Me!
                </div>
                {showAnnouncement && (
                  <Modal
                    size="xl"
                    show={showAnnouncement}
                    onHide={handleClose}
                    centered
                    dialogClassName={
                      isExiting ? "aaa  custom-modal-exit" : "aaa  custom-modal"
                    }
                  >
                    <Modal.Header closeButton>
                      <Modal.Title></Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                      <div className="row m-0 announcement-container">
                        <div className="col-12 col-md-4 col-lg-4">
                          <div
                            className="annc-img-left d-flex justify-content-center"
                            style={{ height: "100%" }}
                          >
                            <img
                              src={hron2}
                              alt="img"
                              style={{
                                objectFit: "contain",
                                width: "100%",
                              }}
                            />
                          </div>
                        </div>
                        <div className="col-12 col-md-8 col-lg-8 p-0">
                          <div>
                            <div className="mb-4">
                              Happy to announce that the Prototype Routes Launch
                              by E-Tender is declared ended on 15.04.2025. The
                              launch was an overwhelming success with the
                              recognition of the inclusive demand for remaining
                              routes for locations in Maharashtra highlighted
                              for procurement of lands on long-lease.
                            </div>
                            <div className="mb-4">
                              We have opened the MH: EAST-WEST Project No. 1 for
                              377 locations of 7 Routes of 7 Cities 19 districts
                              travel 3480 kms alongwith MH: NORTH-SOUTH Project
                              No. 2 for 196 locations of 11 Routes of 28
                              districts travel 3220 kms combining all of
                              Maharashtra valid till 31.03.2030 in phases.
                            </div>
                            <div className="mb-4">
                              Commemorating the 350th Anniversary of the
                              Coronation Ceremony of Chhatrapati Shivaji Maharaj
                              with PM E-Drive Scheme for Charging Infrastructure
                              in this International Co-operatives Year, as a
                              forts conservation initiative – we’ve opened
                              MH-FORT FOOTHILLS Project No. 3 for locations at
                              foothills of 350+ forts in villages at least
                              amongst the 457 fort locations declared list in
                              all over Maharashtra.
                            </div>
                            <div className="mb-4">
                              ICorp portfolio with SERVES DriEVs INDIA program
                              initiates the pilot Demonstration Model of
                              “SERVES” ‘RED: EV-PCS Ezone’ project at the
                              short-listed location within limits of Village
                              Chambhargani Khurd in Taluka Poladpur of District
                              Raigad, Maharashtra, India.
                            </div>
                            <div className="">
                              On activation of the Demonstration Model, the
                              first phase of 20% of identified locations in
                              2025-26 declared in projects on website instigates
                              towards closing of locations initially at almost
                              every 75 to 125 kms on every route to activate
                              each of them in series.
                            </div>
                          </div>
                        </div>
                      </div>
                    </Modal.Body>
                  </Modal>
                )}
              </div>
              {Array.isArray(tab6content)
                ? tab6content.map((itm) => (
                    <div>
                      <div
                        className="d-flex align-items-start gap-3 mb-4"
                        key={itm.id}
                      >
                        <img
                          width={"19px"}
                          className="mt-1"
                          src={tabPointer}
                          alt="img"
                        />
                        <div className="aboutUs-descrip">{itm.description}</div>
                      </div>
                      {/* <div className="mb-4">
                        {itm.subPoints &&
                          itm.subPoints.map((x) => (
                            <div
                              className="d-flex align-items-start gap-3 mb-4 ms-5"
                              key={x.id}
                            >
                              <img
                                width={"8px"}
                                className="mt-1"
                                src={tabPointer2}
                                alt="img"
                              />
                              <div className="aboutUs-descrip">{x.desc}</div>
                            </div>
                          ))}
                      </div> */}
                      <div className="mb-4">
                        {itm.subPoints &&
                          itm.subPoints.map((x) => (
                            <div
                              className="d-flex align-items-start gap-3 mb-4 ms-5"
                              key={x.id}
                            >
                              <img
                                width={"8px"}
                                className="mt-1"
                                src={tabPointer2}
                                alt="img"
                              />
                              <div className="aboutUs-descrip">
                                {highlightMultiple(x.desc, highlights)}
                              </div>
                            </div>
                          ))}
                      </div>
                    </div>
                  ))
                : null}

              <div className="serves-block w-100 mt-5">
                <div className="serveBox">
                  <img src={tab6Img1} alt="car-image" />
                  <div className="fw-bold">
                    <div>Pune - Mumbai expressway</div>
                    {/* <div>(LOA)</div> */}
                  </div>
                </div>
                <div className="serveBox">
                  <img src={tab6Img2} alt="car-image" />
                  <div className="fw-bold">
                    <div>Samruddhi Nagpur - Thane Expressway</div>
                    {/* <div>(CPO)</div> */}
                  </div>
                </div>

                <div className="serveBox">
                  <img src={tab6Img3} alt="car-image" />
                  <div className="fw-bold">
                    <div>Municipal Transport</div>
                    {/* <div></div> */}
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default PartnerPage;
